import {AndroidDeviceDependencies as Dependencies} from '../types';
import {APP_CLIENT_ID as appClient} from '../const';

export function isNativeWebView(di: Dependencies = {}): boolean {
  const {wndw = window} = di;
  const regex = new RegExp(appClient, 'gi');
  return regex.test(wndw.navigator.userAgent);
}
